import { CHANGE_TRUE, CHANGE_FALSE } from './types';

const initialState = {
    change: false
}

const change = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_TRUE:
            return {
                change: true
            }
        case CHANGE_FALSE:
            return {
                change: false
            }
        default:
            return state
    }
}

export default change;